import React from 'react'
import Dashboard from '../../Components/Patient/Dashboard/Dashboard'

const PatientDashboardPage = () => {
  return (
    <div className='p-5'>
      <Dashboard />
    </div>
  )
}

export default PatientDashboardPage
